var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "swiper-gallery grid grid__base" }, [
    _c("div", { ref: "gallery", staticClass: "swiper-container" }, [
      _c(
        "div",
        { staticClass: "swiper-wrapper" },
        _vm._l(_vm.images, function(image, imageIdx) {
          return _c("div", { key: imageIdx, staticClass: "swiper-slide" }, [
            _c("figure", { staticClass: "swiper-gallery--figure" }, [
              _c("div", { staticClass: "swiper-gallery--ratio-wrap-outer" }, [
                _c(
                  "div",
                  { staticClass: "swiper-gallery--ratio-wrap-inner" },
                  [
                    _c(
                      _vm.allowOverlay ? "button" : "div",
                      {
                        tag: "component",
                        staticClass: "swiper-gallery--image-button",
                        on: {
                          click: function($event) {
                            return _vm.onGalleryRequested(imageIdx)
                          }
                        }
                      },
                      [
                        _c(
                          "picture-element",
                          _vm._b(
                            { staticClass: "swiper-gallery--image" },
                            "picture-element",
                            image,
                            false
                          )
                        ),
                        _vm._v(" "),
                        _vm.allowOverlay
                          ? _c(
                              "div",
                              { staticClass: "swiper-gallery--open-gallery" },
                              [
                                _c("ui-icon", {
                                  attrs: {
                                    symbol: "plus",
                                    size: "medium",
                                    "dynamic-size": true
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "figcaption",
                { staticClass: "swiper-gallery--description" },
                [
                  _c(
                    image.href ? "a" : "span",
                    _vm._b(
                      {
                        tag: "component",
                        staticClass: "u-reset swiper-gallery--conditional-link"
                      },
                      "component",
                      _vm.getLinkProps(image),
                      false
                    ),
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(image.caption) +
                          "\n                        "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ])
        }),
        0
      )
    ]),
    _vm._v(" "),
    _vm.images.length > 1
      ? _c("div", { staticClass: "swiper-gallery--buttons" }, [
          _c("div", { staticClass: "swiper-gallery--ratio-wrap-outer" }, [
            _c("div", { staticClass: "swiper-gallery--ratio-wrap-inner" }, [
              _c("div", { staticClass: "swiper-gallery--buttons-inner" }, [
                _c(
                  "div",
                  {
                    staticClass: "swiper-gallery--nav swiper-gallery--nav__prev"
                  },
                  [
                    _c(
                      "button",
                      {
                        ref: "prevButton",
                        staticClass:
                          "swiper-gallery--btn btn btn__secondary btn__square btn__medium"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "swiper-gallery--btn-content btn--wrap"
                          },
                          [
                            _c("ui-icon", {
                              attrs: { symbol: "chevron-left", size: "small" }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "swiper-gallery--nav swiper-gallery--nav__next"
                  },
                  [
                    _c(
                      "button",
                      {
                        ref: "nextButton",
                        staticClass:
                          "swiper-gallery--btn btn btn__secondary btn__square btn__medium"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "swiper-gallery--btn-content btn--wrap"
                          },
                          [
                            _c("ui-icon", {
                              attrs: { symbol: "chevron-right", size: "small" }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e4085214", { render: render, staticRenderFns: staticRenderFns })
  }
}